module.exports = __webpack_public_path__ + "static/main-header-00-d836bf8b716f1c40becd15747c64f559.jpg";